import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ConfigService } from 'src/app/services/config/config.service'
import { FeaturesService } from 'src/app/services/features/features.service'
import { UserProfileDto } from '../../../models/user/user-profile'
import { LogLevel } from '../../../common/log-level'
import { LogService } from '../../../services/logger/log.service'
import { LookupService } from '../../../services/lookup/lookup.service'
import { UserService } from '../../../services/user-service/user-service.service'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  hasTools: boolean
  hasServicePlanFeature: boolean = false
  selectedLanguage: string = 'en'
  languages: any[] = [
    { code: 'en', name: 'English', svg: 'gb' },
    { code: 'ja', name: 'Japanese', svg: 'jp' },
  ]
  constructor(
    private logger: LogService,
    private config: ConfigService,
    private translateService: TranslateService,
    private lookupService: LookupService,
    private userService: UserService,
    private featuresService: FeaturesService,
  ) {
    this.translateService.setDefaultLang('en')
  }

  supportLink: string = this.config.getSettings('spa').customerVoiceLink
  aboutHearHubFeatureLink: string =
    this.config.getSettings('spa').aboutHearHubFeatureLink

  ngOnInit(): void {
    this.userService.hasTools$.subscribe((hasTools) => {
      this.hasTools = hasTools
    })
    this.featuresService.GetFeatures().subscribe({
      next: (features) => {
        this.hasServicePlanFeature =
          features?.find((f) => f.name === 'servicePlan')?.enabled === true
      },
      error: (err) => {
        this.logger.log('Failed to load features', LogLevel.Error, err)
        this.hasServicePlanFeature = false
      },
    })
    this.lookupService.GetUserProfile().subscribe({
      next: (userProfileDto: UserProfileDto) => {
        const savedLang = userProfileDto.language
        if (savedLang) {
          this.selectedLanguage = savedLang
          this.translateService.use(savedLang)
        }
      },
    })
  }

  onLanguageChange(langCode: string) {
    if (langCode !== this.translateService.currentLang) {
      this.selectedLanguage = langCode
      this.translateService.use(langCode)
      const userProfile = new UserProfileDto()
      userProfile.language = langCode
      this.lookupService.SetUserProfile(userProfile).subscribe({
        next: () => {
          this.logger.log(
            'User profile saved successfully',
            LogLevel.Debug,
            userProfile,
          )
        },
        error: (err) => {
          this.logger.log('Failed to save user profile', LogLevel.Error, err)
        },
      })
    }
  }
}
